import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function isSpaRoute(pathname) {
  return (
    pathname === '/provider' ||
    pathname.startsWith('/provider/') ||
    pathname === '/login' ||
    pathname === '/dashboard' ||
    pathname === '/callback'
  );
}

/**
 * index.html embeds a static landing page plus the React root. On first load a
 * small inline script toggles visibility; this keeps that in sync when React
 * Router navigates client-side (e.g. logo → home from /provider/login).
 */
export function LandingVisibilitySync() {
  const { pathname } = useLocation();

  useEffect(() => {
    const landing = document.querySelector('.landing-container');
    const rootEl = document.getElementById('root');
    if (!landing || !rootEl) return;

    if (isSpaRoute(pathname)) {
      landing.style.display = 'none';
      rootEl.style.display = 'block';
      return;
    }

    if (pathname === '/') {
      landing.style.display = 'block';
      rootEl.style.display = 'none';
    }
  }, [pathname]);

  return null;
}

export default LandingVisibilitySync;
